/**
 * MypageRestockContainer
 * --
 */
import React from 'react';
import MypageRestockPresenter from './MypageRestockPresenter';

const MypageRestockContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== Props ===== */
  const { screenSize } = props;
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <MypageRestockPresenter screenSize={screenSize} />
    </>
  );
};

export default MypageRestockContainer;
